import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-features-funfacts',
  templateUrl: './features-funfacts.component.html',
  styleUrls: ['./features-funfacts.component.scss']
})
export class FeaturesFunfactsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
